// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__u8i3L","modalContent":"styles_modalContent__wHX1b"};